import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

import { BaseUser } from '@iot-platform/models/common';

@Component({
  selector: 'oyan-ui-users-user-profile-info',
  templateUrl: './user-profile-info.component.html',
  styleUrls: ['./user-profile-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class UserProfileInfoComponent {
  @Input() currentUser: BaseUser;
  @Output() editUserProfile: EventEmitter<void> = new EventEmitter<void>();
}
